










































































































































































































































































import { Component, Inject, Prop, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IEmailsProviderData,
  IEmailsProviderMethods
} from "@/models/providers/emails";
import { ISentEmail } from "@/models/emails";
import { IClient } from "@/models/clients";
import { ILead } from "@/models/leads";
import { IUser } from "@/models/users";
import { DataModules } from "@/store/modules/data";
import { SentEmailStatus, RecipientTypeCodes } from "@/data/enums/emails";

type IRecipientWithImage = {
  image: {
    full_url;
  };
};

@Component({
  components: {
    "email-history-status": () =>
      import("@/components/app/global/emailHistory/emailHistoryStatus.vue")
  }
})
export default class EmailHistoryTable extends Mixins(Context) {
  // Inject
  @Inject({ from: "emailHistoryProvider" })
  public emailHistoryProvider!: () => IEmailsProviderData;

  @Inject({ from: "emailHistoryMethods" })
  public $emailMethods!: IEmailsProviderMethods;

  // Props
  @Prop({ default: "router-link" })
  public rowTag!: string;

  @Prop({
    default: () => (email: ISentEmail) => ({
      to: {
        name: "adminEmailLog",
        params: { emailId: email.id }
      }
    })
  })
  public rowProps!: (email: ISentEmail) => { [key: string]: string };

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (email: ISentEmail) => { [key: string]: Function };

  // Getters
  public params!: object;

  // Computed
  public get $emailHistoryData() {
    return this.emailHistoryProvider();
  }

  public get emailType() {
    return this.$emailHistoryData.emailType;
  }

  public get table() {
    return this.$emailHistoryData.table;
  }

  public get guardFunctionality() {
    return this.$emailHistoryData.guardFunctionality;
  }

  public get guardFunctionalities() {
    return [this.guardFunctionality];
  }

  public get showViewControl() {
    return this.$userCan("get_email_message");
  }

  public get showManageControls() {
    return this.$userCan("resend_email_message") || this.showViewControl;
  }

  public isError(email: ISentEmail) {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](email) ===
      SentEmailStatus.ERROR
    );
  }

  public isBounced(email: ISentEmail) {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](email) ===
      SentEmailStatus.BOUNCED
    );
  }

  public isSent(email: ISentEmail) {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](email) ===
      SentEmailStatus.SENT
    );
  }

  public recipientIsClient(email: ISentEmail) {
    return [
      RecipientTypeCodes.CLIENT,
      RecipientTypeCodes.CLIENT_WITH_LOGIN,
      RecipientTypeCodes.CLIENT_WITHOUT_LOGIN
    ].includes(email?.recipient_type?.code);
  }

  public recipientIsUser(email: ISentEmail) {
    return [RecipientTypeCodes.USER].includes(email?.recipient_type?.code);
  }

  public recipientIsLead(email: ISentEmail) {
    return [RecipientTypeCodes.LEAD].includes(email?.recipient_type?.code);
  }

  public recipientData(email: ISentEmail) {
    const client = email?.recipient as IClient & IRecipientWithImage;
    const user = email?.recipient as IUser & IRecipientWithImage;
    const lead = email?.recipient as ILead & IRecipientWithImage;

    if (this.recipientIsClient(email))
      return {
        name: client?.fullname,
        email: client?.email,
        imageUrl: client?.image?.full_url,
        to: {
          name: "adminClientEmailHistory",
          params: { clientId: email.recipient_id }
        }
      };
    else if (this.recipientIsUser(email))
      return {
        name: user?.fullname,
        email: user?.email,
        imageUrl: user?.image?.full_url,
        to: {
          name: "adminUserEmailHistory",
          params: { userId: email.recipient_id }
        }
      };
    else if (this.recipientIsLead(email))
      return {
        name: lead?.name,
        email: lead?.email,
        imageUrl: lead?.image?.full_url,
        to: { name: "adminLead", params: { leadId: email.recipient_id } }
      };
  }
}
